import { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import { formatToDecimal, formatToFractional } from '../../../controls/conversions';

// SillHorn — text input, shown only for Standard sill type
const SillHorn = ({ value = { value: '', label: '' }, onChange, disabled = false }) => {
  const [selected, setSelected] = useState(value?.value || '');
  const [error,    setError]    = useState('');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const validate = (v) => {
    const num = parseFloat(formatToDecimal(v));
    if (v && !isNaN(num) && num < 0) {
      setError('Sill Horn must be a positive value');
    } else {
      setError('');
    }
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setSelected(v);
    validate(v);
  };

  const handleFocus = (e) => {
    const dec = formatToDecimal(e.target.value);
    setSelected(dec === '0' || dec === 0 ? '' : dec);
  };

  const handleBlur = (e) => {
    const formatted = formatToFractional(e.target.value);
    setSelected(formatted);
    onChange({ value: formatted, label: formatted });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdSillHorn">Sill Horn</label>
      <input
        id="SdSillHorn"
        value={selected}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        placeholder='e.g. 103"'
      />
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default SillHorn;
